import Vue from 'vue'
import axios from 'axios'
import apiList from '@/service/apiList'
import { Message } from 'element-ui'
import service from '@/service/chat_api'

const host = myhostname;

// 获取商城分类
function login (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.post(apiList.login, params)
      .then(function (res) {
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('shop_id', res.data.shop_id)
        localStorage.setItem('username', res.data.nickname)
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}

// 获取供应商id



// // 获取是否直发
// function getShopType (params) {
//   return new Promise((resolve) => {
//     Vue.prototype.$api.get(apiList.getShopType, params)
//       .then(function (res) {
//         console.log(res)
//         resolve()
//       })
//       .catch(function (err) {
//         console.log(err)
//       })
//   })
// }
// 获取店铺信息
function getShopDetail (params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api.get(apiList.getShopDetail, params)
      .then(function (res) {
        resolve(res.data)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description r4gys获取R4供应商权限
 */
function loadSettleType (params) {
  console.log(params, "params");
  return new Promise((resolve, reject) => {
    service.get(`${host}/pay/settle-type`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取打印数据
function getPrintData (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.post(apiList.print, params)
      .then(function (res) {
        if (res.data && res.data.length === 0) {
          Message.warning('无箱码，请先填写打包数生成箱码')
        }
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
function sleep (fn, par) {
  return new Promise((resolve) => {
    // wait 3s before calling fn(par)
    setTimeout(() => resolve(fn(par)), 3000)
  })
}
// 打印
async function print (params = {}) {
  try {
    axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-81'
    let res
    await sleep(async () => {
      res = await axios.post('http://127.0.0.1:4050/', JSON.stringify(params))
    })
    res = res.data
    return new Promise((resolve, reject) => {
      if (res.code === 200) {
        Message.success('生成PDF成功')
        resolve(res)
      } else {
        Message.error('未安装PDF生成插件')
        reject(res)
      }
    })
  } catch (err) {
    Message.error('未安装PDF生成插件')
    return new Promise((resolve, reject) => {
      resolve(false)
    })
  }
}
// 获取是否新订单
function audioOrder (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.audioOrder, params)
      .then(function (res) {
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
export { login, getShopDetail, getPrintData, print, audioOrder, loadSettleType }



// WEBPACK FOOTER //
// ./src/models/commonModel.js